// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
.train-number-picker-panel {
  width: 332px;
  max-width: 332px;
  box-sizing: border-box;
  overflow: hidden;
}

.picker-header {
  align-items: center;
  gap: 8px;
}
.picker-header .clear-text-btn-primary {
  flex: 0 0 auto;
}

.picker-header__title {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.info-btn-container {
  display: inline-flex;
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
}

.info-btn {
  border: 2px solid #9dbcda;
  background: transparent;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-btn svg {
  position: static;
}

.train-filtering-container {
  margin-top: 1em;
  max-width: 100%;
}

.train-filtering-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 100%;
  margin-top: 0.5em;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
